import { PeriodDayEditionForm } from "@app/grid/PeriodDayEditionForm";
import { PeriodYearEditionForm } from "@app/grid/PeriodYearEditionForm";
import { Period, PeriodType, PeriodTypeDay, PeriodTypeMonth, PeriodTypeQuarter, PeriodTypeWeek, PeriodTypeYear } from "@dto/period";
import { PeriodMonthAndYearEditionForm } from "./PeriodMonthAndYearEditionForm";
import { PeriodQuarterAndYearEditionForm } from "./PeriodQuarterAndYearEditionForm";
import { PeriodWeekAndYearEditionForm } from "./PeriodWeekAndYearEditionForm";


interface PeriodEditorProps {
    initialPeriod: Period | undefined;
    periodType: PeriodType | undefined;
    updatePeriod: (period: Period | undefined) => void;
    disabled: boolean;
    className?: string;
}

export function PeriodEditor({ initialPeriod, periodType, updatePeriod, disabled, className}: PeriodEditorProps) {

    switch (periodType) {
        case PeriodTypeYear:
            return <PeriodYearEditionForm field={undefined} value={initialPeriod} updatePeriod={updatePeriod} searchValue="" setSearchValue={undefined} searchInputRef={undefined} displaySearch={false} hasValidation={false} disabled={disabled} className={className} />
        case PeriodTypeQuarter:
            return <PeriodQuarterAndYearEditionForm field={undefined} value={initialPeriod} updatePeriod={updatePeriod} searchValue="" setSearchValue={undefined} searchInputRef={undefined} displaySearch={false} hasValidation={false} disabled={disabled} className={className} />
        case PeriodTypeMonth:
            return <PeriodMonthAndYearEditionForm field={undefined} value={initialPeriod} updatePeriod={updatePeriod} searchValue="" setSearchValue={undefined} searchInputRef={undefined} displaySearch={false} hasValidation={false} disabled={disabled} className={className} />
        case PeriodTypeWeek:
            return <PeriodWeekAndYearEditionForm field={undefined} value={initialPeriod} updatePeriod={updatePeriod} searchValue="" setSearchValue={undefined} searchInputRef={undefined} displaySearch={false} hasValidation={false} disabled={disabled} className={className} />
        case PeriodTypeDay:
            return <PeriodDayEditionForm field={undefined} value={initialPeriod} updatePeriod={updatePeriod} searchValue="" setSearchValue={undefined} searchInputRef={undefined} displaySearch={false} hasValidation={false} disabled={disabled} className={className} />
        default:
            return null;
    }
}